module.exports = { id: "vimeo", url: "/build/app/img/symbols.svg#vimeo", viewBox: "", toString: function() { return this.url; } };